import { Layout, Spin } from 'antd'

export default function LoadingComponent() {
  return (<Layout className={'loading-component'}>
    <Spin tip={'Loading...'} size="large" style={{ margin: '3rem', height: '500px' }} />
  </Layout>)
}